import { Injectable } from '@angular/core';
import { AbstractDialogService, DialogOptions } from '@examdojo/core/dialog';
import { DailyHoursMap } from '../payments.model';
import { WorkingHoursDialogComponent } from './working-hours-dialog.component';

export interface WorkingHoursDialogInput {
  period: string;
  existingHours: DailyHoursMap;
  isReadonly: boolean;
  isExistingRequest: boolean;
  hourlyPaymentRate: number;
  existingRequestPeriods: string[];
}

export interface WorkingHoursDialogResult {
  period: string;
  hours: DailyHoursMap;
  shouldSubmit: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class WorkingHoursDialogService extends AbstractDialogService<
  WorkingHoursDialogInput,
  WorkingHoursDialogResult,
  typeof WorkingHoursDialogComponent
> {
  readonly id = 'working-hours-dialog';
  protected readonly component = WorkingHoursDialogComponent;

  protected override readonly options: DialogOptions = {
    cssClass: 'fullscreen',
    showBackdrop: true,
    handle: false,
  };

  override openDialog(config: { input: WorkingHoursDialogInput; options?: DialogOptions }) {
    return super.openDialog({
      ...config,
      options: {
        ...this.options,
        ...config.options,
        componentProps: {
          period: config.input.period,
          existingHours: config.input.existingHours,
          isReadonly: config.input.isReadonly,
          isExistingRequest: config.input.isExistingRequest,
          hourlyPaymentRate: config.input.hourlyPaymentRate,
          existingRequestPeriods: config.input.existingRequestPeriods,
        },
      },
    });
  }
}
